module.exports = __webpack_public_path__ + "img/Granada.d073c4a8.png";